//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').filter('capitalize',
        () => function(input) {
          const ucList = [];
          if (!!input && typeof input === 'string') {
            input.split(' ').forEach((s) => {
              ucList.push(s.charAt(0).toUpperCase() + s.substr(1).toLowerCase());
            });
            return ucList.join(' ');
          }
          return input;
        },
    );
})();
